import {
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    GET_AVAILABLE_UNITS_REQUEST,
    GET_AVAILABLE_UNITS_FAILURE,
    GET_AVAILABLE_UNITS_SUCCESS,
    EDIT_CASE_DETAILS_REQUEST,
    EDIT_CASE_DETAILS_SUCCESS,
    EDIT_CASE_DETAILS_FAILURE,
    CANCEL_CASE_REQUEST,
    CANCEL_CASE_SUCCESS,
    CANCEL_CASE_FAILURE,
    CONVERT_CASE_REQUEST,
    CONVERT_CASE_SUCCESS,
    CONVERT_CASE_FAILURE,
    EDIT_ADMIN_CASE_NOTES_REQUEST,
    EDIT_ADMIN_CASE_NOTES_SUCCESS,
    EDIT_ADMIN_CASE_NOTES_FAILURE,
    CHANGE_CASE_STATUS_SUCCESS,
    CHANGE_CASE_STATUS_FAILURE,
    CHANGE_CASE_STATUS_REQUEST
} from './constants';

export function getCase(caseId) {
    return {
        type: GET_CASE_DETAILS_REQUEST,
        caseId: caseId
    }
}

export function getCaseSuccess(response) {
    return {
        type: GET_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function getCaseFailure() {
    return {
        type: GET_CASE_DETAILS_FAILURE,
        data: {}
    }
}

export function editCase(data) {
    return {
        type: EDIT_CASE_DETAILS_REQUEST,
        data: {patient: data.patient, callBack:data.callBack}
    }
}

export function editCaseSuccess(response) {
    return {
        type: EDIT_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function editCaseFailure() {
    return {
        type: EDIT_CASE_DETAILS_FAILURE,
        data: {}
    }
}

export function getAvailableUnits(data) {
    return {
        type: GET_AVAILABLE_UNITS_REQUEST,
        data: data
    }
}

export function getAvailableUnitsSuccess(response) {
    return {
        type: GET_AVAILABLE_UNITS_SUCCESS,
        data: response
    }
}

export function getAvailableUnitsFailure() {
    return {
        type: GET_AVAILABLE_UNITS_FAILURE,
        data: {}
    }
}

export function cancelCase(caseId) {
    return {
        type: CANCEL_CASE_REQUEST,
        data: {caseId}
    }
}

export function cancelCaseSuccess(response) {
    return {
        type: CANCEL_CASE_SUCCESS,
        data: response
    }
}

export function cancelCaseFailure() {
    return {
        type: CANCEL_CASE_FAILURE,
        data: {}
    }
}

export function convertCase(data) {
    return {
        type: CONVERT_CASE_REQUEST,
        data
    }
}

export function convertCaseSuccess(response) {
    return {
        type: CONVERT_CASE_SUCCESS,
        data: response
    }
}

export function convertCaseFailure(response) {
    return {
        type: CONVERT_CASE_FAILURE,
        data: response
    }
}

export function editAdminCaseNotes(data){
    return {
        type: EDIT_ADMIN_CASE_NOTES_REQUEST,
        data
    }
}

export function editAdminCaseNotesSuccess(response){
    return {
        type: EDIT_ADMIN_CASE_NOTES_SUCCESS,
        data: response
    }
}

export function editAdminCaseNotesFailure(response){
    return {
        type: EDIT_ADMIN_CASE_NOTES_FAILURE,
        data: {}
    }
}

export function changeCaseStatus(data) {
    return {
        type: CHANGE_CASE_STATUS_REQUEST,
        data: {data, isCaseForm: true}
    }
}

export function changeCaseStatusSuccess(data) {
    return {
        type: CHANGE_CASE_STATUS_SUCCESS,
        data: {data}
    }
}

export function changeCaseStatusFailure(data) {
    return {
        type: CHANGE_CASE_STATUS_FAILURE,
        data: {data}
    }
}





// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AdminCaseDetails/actions.js